interface SlideHeadingProps {
  heading: string;
  titleRef?: any;
}

export default function SlideHeading({ heading, titleRef }: SlideHeadingProps) {
  return (
    <p ref={titleRef} className="text-[24px] md:text-[32px] text-black">
      {heading}
    </p>
  );
}
